export const executives2023 = 20734
export const executives2024 = 18967
export const executives2025 = 16407
export const executives2026 = 598
export const executivesTotal = 25979
